import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import App from 'modules/App';
import styles from './TopBar.pcss';
const TopBar = ({ children })=>{
    const isPrintMode = useSelector(App.selectors.printMode);
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.topBarHolder, {
            [styles.hide]: isPrintMode
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.topBar,
            children: children
        })
    });
};
export default TopBar;
